import styled from 'styled-components';
import { NAVIGATION_BAR_HEIGHT } from 'utility/css/values';

export const Top = styled.div`
  height: ${NAVIGATION_BAR_HEIGHT}px;
`;
